<div class="floor-planner floor-viewer">

  <div *ngIf='dataLoading' class="dataLoading m-auto">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>


  <div class="design-area-wrapper">

    <div *ngIf="!floor?.tabels?.length" class="h-100 d-flex align-items-center justify-content-center">
      <h5 class="m-0">{{'reservations.No available tables' | translate}}</h5>
    </div>

    <div class="design-area" *ngIf="floor?.tabels?.length" [ngStyle]="{
        'width': screesDim.screenWidth + 'px',
        'height': screesDim.screenHeight + 'px',
        'transform': 'scale(' + this.scale + ')',
        'zoom-bla': this.scale
      }">

      <div class="dragable-item" *ngFor="let item of floor.tabels" cdkDrag cdkDragDisabled
        [cdkDragFreeDragPosition]="item.position">

        <div class="shape-wrapper">
          <!-- Shape Type Container -->
          <div class="shape-container" [ngClass]="{
              'selected': item.selected,
              'blocked': item.tableStatus == 'Blocked',
              'reserved': item.currentReservations?.reservationStatus == 'Reserved' || item.tableStatus == 'Reserved',
              'seated': item.currentReservations?.reservationStatus == 'Seated',
              'arrived': item.currentReservations?.reservationStatus == 'Arrived'
            }">
            <!-- Text -->
            <div *ngIf="item.type == 4" class="text">
              <h4>{{item.text}}</h4>
            </div>

            <!-- Shape -->
            <div class="shape square" (click)="tableSelected(item)" *ngIf="item.type !== 4" [ngStyle]="{
                'width': item.width + 'px',
                'height': item.height + 'px',
                'transform':'rotate(' + item.rotation + 'deg)'
              }" [ngClass]="{
                'table': item.category === 1,
                'square': item.type === 1,
                'rectangle': item.type === 2,
                'round': item.type === 3
              }">

              <ng-container *ngIf="item.category == 1">
                <div class="table-details">
                  <div class="content">
                    <div class="table-name">
                      <span *ngIf="item.name" [matTooltip]="item.name">
                        {{item.name | slice:0:4}} {{ item.name.length > 4 ? '...' : ''}}
                      </span>
                      <div>
                        <div class="server-img"
                          *ngFor="let item of item.tableWaiters"
                          [hidden]="!item.isSelected && currentView != 2">
                          <div>
                            <img [src]="item.profilePic" alt="" *ngIf="item.profilePic" (error)="item.profilePic = ''">
                            <span *ngIf="!item.profilePic">{{item.name | shortName}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="reservation-info">
                      <div class="reserv-info">
                        <div class="info-span">
                          <ng-container *ngIf="item.tableStatus == 'Free'">{{'reservations.Free' |
                            translate}}</ng-container>
                          <ng-container *ngIf="item.tableStatus == 'Reserved'">{{'reservations.Reserved' |
                            translate}}</ng-container>
                          <ng-container *ngIf="item.tableStatus == 'Blocked'">{{'reservations.Blocked' |
                            translate}}</ng-container>
                        </div>

                        <ng-container *ngIf="item.currentReservations">
                          <div class="guest-name" [matTooltip]="item.currentReservations.customerName">
                            {{item.currentReservations.customerName}}
                          </div>
                          <div class="info-span">{{item.currentReservations.reservationTimeFrom}}</div>
                        </ng-container>
                      </div>

                      <div class="recommend" *ngIf="item.recommended">
                        <img src="./assets/images/icons/planner/ic_recommended.svg">
                      </div>
                    </div>

                    <div class="table-time-list" *ngIf="currentView == 1 && item.tableReservations?.length">
                      <div *ngFor="let Restime of item.tableReservations">{{Restime.reservationTimeFrom}}</div>
                    </div>
                  </div>
                </div>

                <div class="chairs">
                  <div class="top" *ngIf="item.seats! > 0">
                    <div class="chair"></div>
                  </div>
                  <div class="bottom" *ngIf="item.seats! > 1">
                    <div class="chair"></div>
                  </div>
                  <div class="left" *ngIf="item.seats! > 2">
                    <div class="chair"></div>
                  </div>
                  <div class="right" *ngIf="item.seats! > 3">
                    <div class="chair"></div>
                  </div>
                </div>
              </ng-container>

            </div>
          </div>
          <!-- End Shape Type Container -->
          <div class="badge align-self-center">{{item.seats}}</div>
        </div>

      </div>

    </div>
  </div>

  <div class="selected-table" *ngIf="tables.length && !isView">
    <label>{{'reservations.Selected table(s)' | translate}}</label>
    <div class="selected-value">
      <ng-container *ngFor="let item of tables; index as i"><ng-container *ngIf="i > 0">,
        </ng-container>{{item.name}}</ng-container>
    </div>
    <span class="warning" matRipple *ngIf="hasProblem" (click)="openProblemsDialog()">
      <img src="./assets/images/icons/warning-ic.svg" alt="">
    </span>
  </div>

  <div class="planner-action">
    <div>
      <button type="button" class="info-btn large" mat-icon-button [matMenuTriggerFor]="menu">
        <img src="./assets/images/icons/info-outline-gray.svg" alt="">
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item *ngIf="currentView != 0" (click)="currentView = 0">{{'reservations.Current reservation' | translate}}</button>
        <button mat-menu-item *ngIf="currentView != 1" (click)="currentView = 1">{{'reservations.Time of reservations' | translate}}</button>
        <button mat-menu-item *ngIf="currentView != 2" (click)="currentView = 2">{{'reservations.Assigned server' | translate}}</button>
      </mat-menu>

      <button type="button" class="btn border ml-3" mat-button
        *ngIf="reservationDate"
        (click)="openServarsList = !openServarsList">
        <img src="./assets/images/icons/bow-tie-ic.svg" alt=""><span> {{ 'servers.Servers' | translate }}</span>
      </button>
    </div>

    <mat-button-toggle-group *ngIf="floor?.tabels?.length">
      <mat-button-toggle [disabled]="scale <= minScale" [class.mat-button-toggle-checked]="false"
        (click)="setZoom('out')">
        <mat-icon>remove</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle [class.mat-button-toggle-checked]="false" (click)="setZoom('fit')">
        {{ 'planner.Fit' | translate }}
      </mat-button-toggle>
      <mat-button-toggle [disabled]="scale >= maxScale" [class.mat-button-toggle-checked]="false"
        (click)="setZoom('in')">
        <mat-icon>add</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <select [(ngModel)]="floorId" class="form-control" (ngModelChange)="floorChanged()">
      <option [value]="item.id" *ngFor="let item of floors">{{item.name}}</option>
    </select>
  </div>
</div>


<app-servers *ngIf="openServarsList"
  [open]="openServarsList == true"
  [restaurantId]="restaurantId"
  [reservationDate]="reservationDate"
  (close)="openServarsList = false">
</app-servers>
